// general functions
$(window).on('load', function() {showMessageOnIE()});
AOS.init();

if ($('.defaultNav').length) {
    var scroll_init = 0;
    $(window).on('scroll', function(event) {
        var scroll_body = $(this).scrollTop();
        var nav = $('nav');

        /*
            Aplica a classe que contem o estilo
            primário para o nav quando a pagina
            executar o evento scroll
        */
        if (scroll_body > 199) {
            nav.addClass("defaultNav--scroll");
        } else {
            nav.removeClass("defaultNav--scroll");
        }

        /*
            Quando a página rolar 600px pra baixo o nav
            desaparece e recebe a classe "middle" para
            identificar o estado.
        */
        if (scroll_body > 600) {
            nav.addClass("defaultNav--hide");
            nav.addClass("defaultNav--middle");
        } else {
            nav.removeClass("defaultNav--hide");
            nav.removeClass("defaultNav--middle");
        }

        /*
            verifica se o scroll da página foi
            pra cima, caso sim faz o menu aparecer.
        */
        if (scroll_body < scroll_init) {
            nav.removeClass("defaultNav--hide");
        }

        // var referencia
        scroll_init = scroll_body;

        // close menu on scroll
        $('.menu__firstSub').removeClass('is-active');
    });

    // open/close hamburguer menu
    $('.c-hamburguer').on('click', function() {
        $(this).toggleClass('is-active');
        $('.defaultNav__contentNav').toggleClass('is-active');
        $('.defaultNav__maskMenu').toggleClass('is-active');
        $('.u-maxRow').toggleClass('nav__is-active');
        $('body').toggleClass('u-overflowBlocked');
    });

    // close hamburguer menu
    $('.defaultNav__maskMenu').on('click', function() {
        $('.c-hamburguer').removeClass('is-active');
        $('.defaultNav__contentNav').removeClass('is-active');
        $('.defaultNav__maskMenu').removeClass('is-active');
        $('.u-maxRow').removeClass('nav__is-active');
        $('body').removeClass('u-overflowBlocked');
    });

    // abrir menu sub menu
    $('.menu__withSub > a').on('click', function(event) {
        event.preventDefault();
        $(this).parent('li').children('.menu__firstSub').toggleClass('is-active');
    });
    $('.defaultNav .menu__firstSub a').on('click', function() {
        $('.menu__firstSub').removeClass('is-active');
    });
}

// fix bug svg path in iphone
if(is.iphone()) {
    var finalPage = $('body').attr('data-pathName');
    $('.js-svgNewGradientURL').each(function() {
        var fillUrl = $(this).attr('fill').replace('#', './'+finalPage+'#');
        $(this).attr('fill', fillUrl);
    });
}
if ($('.liSelect').length) {
    $('.liSelect select').on('focusin', function () {
        $(this).parent('.liSelect').addClass('is-active');
    });
    $('.liSelect select').on('focusout', function () {
        $(this).parent('.liSelect').removeClass('is-active');
    });
}

